import React, {Component} from 'react'

import { FormGroup, FormControl, Form, Button, ControlLabel, Radio} from 'react-bootstrap';

import './ContactForm.css';

const RadioGroup = ({label, name, values, onChange}) => {
  let radioButtons = 
    values.map(value => (
      <Radio key={value} name={name} onChange={onChange} value={value} required>
        {value}
      </Radio>
    ));
  return (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <RedAsterisk/>
      {radioButtons}
    </FormGroup>
  );
}

const RedAsterisk = () => {
  return (
    <span style={{color: "red"}}>&nbsp;&#42;</span>
  );
}

class ContactForm extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  getFormData() {
    let data = {
      type: "design",
      name: this.name.value,
      phone: this.phone.value,
      city: this.city.value,
      size: this.size.value,
      note: this.note.value
    }
    if (this.wechat.value) {
      data.wechat = this.wechat.value
    }
    if (this.email.value) {
      data.email = this.email.value
    }
    if (this.state.serviceType) {
      data.serviceType = this.state.serviceType
    }
    if (this.state.projectType) {
      data.projectType = this.state.projectType
    }
    if (this.state.when) {
      data.when = this.state.when
    }
    return data
  }

  selectServiceType = (e) => {
    this.setState({serviceType: e.target.value})
  }

  selectProjectType= (e) => {
    this.setState({projectType: e.target.value})
  }

  selectWhen= (e) => {
    this.setState({when: e.target.value})
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.serviceType !== this.state.serviceType) {
      return false
    }
    if (nextState.projectType !== this.state.projectType) {
      return false
    }
    if (nextState.when !== this.state.when) {
      return false
    }
    return true
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <Form onSubmit={handleSubmit}>
        <FormGroup controlId="formName">
          <ControlLabel>Client Name</ControlLabel>
          <RedAsterisk/>
          <FormControl type="name" placeholder="Enter Your Name" inputRef={ref => { this.name = ref; }} required/>
        </FormGroup>

        <FormGroup controlId="formPhone">
          <ControlLabel>Phone</ControlLabel>
          <RedAsterisk/>
          <FormControl type="phone" placeholder="Enter Your Phone Number" inputRef={ref => { this.phone = ref; }} required/>
        </FormGroup>

        <FormGroup controlId="formWechat">
          <ControlLabel>WeChat Id</ControlLabel>
          <FormControl type="wechat" placeholder="Enter Your WeChat Id" inputRef={ref => { this.wechat = ref; }} />
        </FormGroup>

        <FormGroup controlId="formEmail">
          <ControlLabel>Email</ControlLabel>
          <FormControl type="email" placeholder="Enter Your Email" inputRef={ref => { this.email = ref; }} />
        </FormGroup>

        <RadioGroup label="Design Service Type"
                    name="serviceType"
                    values={["New Construction", "Remodel", "Furniture Selection", "Design Consultant (charge by hours)"]}
                    onChange={this.selectServiceType} />

        <RadioGroup label="Project Type"
                    name="projectType"
                    values={["Single Family", "Town House", "Condo", "Other"]}
                    onChange={this.selectProjectType} />

        <RadioGroup label="How Soon Do You Need The Service"
                    name="when"
                    values={["Now", "1-2 weeks", "2-6 weeks", "6+ weeks"]}
                    onChange={this.selectWhen} />

        <FormGroup controlId="formCity">
          <ControlLabel>City</ControlLabel>
          <RedAsterisk/>
          <FormControl type="city" placeholder="City" inputRef={ref => { this.city = ref; }} required/>
        </FormGroup>

        <FormGroup controlId="formSize">
          <ControlLabel>Project Size</ControlLabel>
          <RedAsterisk/>
          <FormControl type="size" placeholder="Enter square footage" inputRef={ref => { this.size = ref; }} required/>
        </FormGroup>

        <FormGroup controlId="formNote">
          <ControlLabel>Additional Information</ControlLabel>
          <FormControl componentClass="textarea" rows="5" placeholder="Enter additional information" 
                       inputRef={ref => { this.note = ref; }} />
        </FormGroup>

        <FormGroup>
          <Button bsStyle="primary" type="submit">Submit</Button>
        </FormGroup>
      </Form>
    );
  }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/ContactForm.js